import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
  name: 'product-import-and-export',
  namespaced: true,
  state,
  actions,
  mutations,
};
